import $ from 'jquery';

/**
 * Custom Scripts
 */
import Form from './custom/forms';
// import SocialMedia from './custom/bjzm-social-feeds';
import BjzmScripts from './custom/bjzm-scripts';
import Slider from './custom/bjzm-slideshow.js';

import BjzmLoadMorePosts from './custom/bjzm-load-more-posts';
import HeaderScroll from './custom/header-scroll';
import SinglePageUpdown from './custom/single-page-updown';
import BjzmFormScripts from './custom/bjzm-form-scripts';
import AppWebApiUtilities from './custom/app-web-api-utilities';

/**
 * Vendors
 */
import matchHeight from './vendors/jquery.matchHeight';
import magnificPopup from 'magnific-popup';


jQuery(document).ready(function($) {

 	var ThemeScripts = new BjzmScripts();
 	var RegisterFormScripts = new BjzmFormScripts();
 	// var WebApiUtilities = AppWebApiUtilities();

 	if( $('.broker-svg').length > 0) {
 		var pageHeight = $(".bjzm-wrapper--page").outerHeight();
 		var footerHeight = $(".footer--main").outerHeight();
 		var headerHeight = $(".header--main").outerHeight();
 		var totalHeight = pageHeight + footerHeight + headerHeight;
 		$(".header__logo-svg-wrapper").height( totalHeight );
 	}

	/* Load More Posts */
	var LoadMorePosts = new BjzmLoadMorePosts({
		query_vars: BJZM_DATA.query_vars,
		ajax_url: BJZM_DATA.ajaxurl,
		max_num_pages: BJZM_DATA.max_num_pages,
		post_loop: $(".bjzm-wrapper__row--blog-posts"),
		template_partial: 'content-full-width-article'
	});

	var subMenuScroll = new SinglePageUpdown({
		container: $(".hero__content-items"),
		offset: 0,
		changeHash: false
	});

	/* Homepage Slideshow*/
	var HomeSlider = new Slider("home_slider", {
		dots: true,
		customPaging : function(slider, i) {
 			return '<a href="#" class="slider__dots"></a>';
 		}
 	});


	/* Header Scroll */
	// var MainHeaderScroll = new HeaderScroll({
	// 	header: $(".header--collapse"),
	// 	threshold: 300,
	// 	class: 'header--collapsed'
	// });
	

	/*privacy policy*/
	$('.lightbox').magnificPopup({
 		type: 'inline',
		midClick: true,
		removalDelay: 300,
		mainClass: 'mfp-fade mfp-wrap--privacy-policy'
	});


	$(".show-hero").change(function(){
		$(".home-wrapper").toggleClass('hero-map');
	});

	

 	function firetag(src) {
 		var evp = document.createElement('img');
 		evp.height = 1;
 		evp.width = 1;
 		evp.style.display = "none";
 		evp.src = src;
 		document.body.appendChild(evp);
 	}

 	function addScript( src ) {
 		var s = document.createElement( 'script' );
 		s.setAttribute( 'src', src );
 		document.body.appendChild( s );
 	}

	$(document).on('gform_confirmation_loaded', function(){
		$('.hero__content-text').addClass('hidden');
		$('.hero__content-heading').addClass('hidden');
		$('.branchmask').addClass('hidden');
		$('.hero__img-inner').css({overflow : 'visible'});
		$('.bjzm-form').css({animation: '0'});

		fbq('track', 'CompleteRegistration');
		gtag('event', 'formSubmit', {
			'event_category':'CompleteRegistration'
		});

		console.log('tracking conversions');

		firetag('https://acuityplatform.com/Adserver/pxlj/4931250861625022464');
	});


	$(document).on('gform_confirmation_loaded', function(event, formId){
		  /*acuity conversion*/
		  /* <script src="https://acuityplatform.com/Adserver/pxlj/4931250861625022464?" type="text/javascript" async  ></script> */
		  // (function(pixelKey) {
		  // 	try {
		  // 		var script = document.createElement("script");
		  // 		script.src = '//acuityplatform.com/Adserver/pxlj/'+pixelKey+'?'; script.async = true; document.getElementsByTagName("body")[0].appendChild(script);
		  // 	} catch(e) {};
		  // }) ('*4931250861625022464*');
	});
		
});









